import apiRequest from 'api/apiRequest';
import endpoints from 'api/endpoints';
import { ShipmentBundle } from 'api/optimalprint-sdk.d';
import { HttpMethods } from 'api/types';
import useLocale from 'hooks/useLocale';
import React, { FC, useEffect, useState } from 'react';
import styles from './StudioOPPlusFreeShipping.module.scss';

export interface StudioOPPlusFreeShippingProps {
  categoryId: number;
  productId: number;
}

const StudioOPPlusFreeShipping: FC<StudioOPPlusFreeShippingProps> = ({ categoryId, productId }) => {
  const locale = useLocale();
  const [deliveryDetails, setDeliveryDetails] =
    useState<ShipmentBundle.Entity.API.ShipmentPrice.ShipmentPriceListV2Response>();

  const fetchDeliveryDetails = async () => {
    const deliveryData = (await apiRequest(
      endpoints.shipmentPriceV2List,
      {
        productIds: [productId],
        categoryId,
        locale,
      },
      HttpMethods.POST,
      'data',
    )) as ShipmentBundle.Entity.API.ShipmentPrice.ShipmentPriceListV2Response;
    setDeliveryDetails(deliveryData);
  };

  useEffect(() => {
    fetchDeliveryDetails();
  }, [categoryId, productId]);

  if (!deliveryDetails) {
    return null;
  }

  if ((deliveryDetails as any).opplus.isOpPlusSubscribed) {
    return null;
  }
  return (
    <div
      className={styles.OPPlusFreeShipping}
      dangerouslySetInnerHTML={{ __html: (deliveryDetails as any).opplus.opPlusProductPageDescription }}
    />
  );
};

export default StudioOPPlusFreeShipping;
